<div class='menu-bar'>
  <!--will be moved to header-->
  <!--  <div (click)='openNotificationsOverlay(notificationsDialog)' class='menu-bar__alarm'>-->
  <!--    <app-alarm-bell class='alarm-bell'></app-alarm-bell>-->
  <!--  </div>-->
  <div class='menu-bar__main'>
    <!--    <nb-menu [items]='mainMenuItems' [ngClass]='profileActive()' tag='menu'></nb-menu>-->
    <ul class='menu-items'>
      <li *ngFor='let menuItem of mainMenuItems; let i = index;' class='menu-item' nbTooltip='{{menuItem.title}}'
          nbTooltipPlacement='right'>
        <a (click)='onItemClick(i);'
           (mouseenter)='onHoverItem(menuItem)'
           *ngIf='menuItem.link && !menuItem.url && !menuItem.children && !menuItem.group'
           [attr.target]='menuItem.target'
           [class.active]='menuItem.selected'
           [fragment]='menuItem.fragment'
           [preserveFragment]='menuItem.preserveFragment'
           [queryParamsHandling]='menuItem.queryParamsHandling'
           [queryParams]='menuItem.queryParams'
           [routerLink]='menuItem.link'
           [skipLocationChange]='menuItem.skipLocationChange'>

          <nb-icon *ngIf='menuItem.icon' [config]='menuItem.icon' class='menu-icon'></nb-icon>
        </a>
      </li>
    </ul>
  </div>
  <div class='menu-bar__login'>
    <ul [nbPopover]='templateRef' class='menu-items' nbPopoverPlacement='right' nbPopoverTrigger='click'>
      <li *ngFor='let menuItem of loginMenuItems' class='menu-item'>
        <nb-icon *ngIf='menuItem.icon' [config]='menuItem.icon' [ngClass]='{ active: menuItem.selected }'
                 class='menu-icon'></nb-icon>
      </li>
    </ul>
  </div>
</div>
<!--will be moved to header-->
<!--<ng-template #notificationsDialog let-data let-ref='dialogRef'>-->
<!--  <div class='notifications-overlay-container'>-->
<!--    <div (click)='ref.close()' class='close-notifications'>-->
<!--      <nb-icon icon='close-circle-outline'></nb-icon>-->
<!--    </div>-->
<!--    <app-notifications [facilitySelection]="'divisionsNotifications'"></app-notifications>-->
<!--  </div>-->
<!--</ng-template>-->
<ng-template #templateRef>
  <div class='sidebar-context-menu'>
    <nb-menu (click)='close()' [items]='items' class='sidebar-context-menu-items'></nb-menu>
  </div>
</ng-template>

